import * as types from './actionTypes';
import trackService from '../services/trackService';
import { fetch, addTask } from 'domain-task';
import ToastrService from '../services/toastrService';
import swal from 'sweetalert';
import moment from 'moment';

export function getFeaturedTracks() {
    return (dispatch, getState) => {
        if(getState().tracks.featuredTracks.length == 0) {
            let fetchTask = trackService.getFeaturedTracks()
                .then(tracks => {
                    if(tracks) {
                        dispatch({ type: types.GET_FEATURED_TRACKS, tracks });
                    }
                    return tracks;
                });
            addTask(fetchTask);
        }
    };
}

export function getTrack(trackID) {
    return (dispatch, getState) => {
        const existingTrack = getState().tracks.selectedTrack;
        if(!existingTrack || existingTrack.Track.ID !== parseInt(trackID, 10)) {
            let fetchTask = trackService.getTrack(trackID)
                .then(track => {
                    if(track) {
                        dispatch({ type: types.GET_TRACK, track });
                    }
                    return track;
                })
            addTask(fetchTask);
            return fetchTask;
        }
        else {
            return Promise.resolve(true);
        }
    };
}

function dispatchStatusUpdate(dispatch, type, status) {
    let loadingStatus = { status: status };
    dispatch({ type, loadingStatus });
}

export function getCharts(forceReload = false) {
    return (dispatch, getState) => {
        const state = getState();
        if(state.tracks.charts.length == 0 || forceReload || new Date(state.tracks.chartsLastLoaded) < moment().subtract(10, 'minutes')) {
            dispatchStatusUpdate(dispatch, types.GET_MUSIC_CHARTS_STATUS, 'LOADING');
            let fetchTask = trackService.getCharts()
                .then(charts => {
                    if(charts) {
                        dispatch({type: types.GET_MUSIC_CHARTS, charts});
                        dispatchStatusUpdate(dispatch, types.GET_MUSIC_CHARTS_STATUS, 'LOADED');
                    }
                    return charts;
                })
                .catch(error => {
                    dispatchStatusUpdate(dispatch, types.GET_MUSIC_CHARTS_STATUS, 'FAILED');
                });
            addTask(fetchTask);
        }
    };
}

function playTrack(trackID, currentProfileID){
    return function(dispatch, getState) {
        const tracks = getState().tracks;
        if(!tracks.trackPlayed) {            
            //we need this for iOS devices, it would also need to be done on click rather than 
            //here where it's after we've got the track details from the api
            $('#jquery_jplayer_1').jPlayer("setMedia", {
                mp3: '/Media/init.mp3'
            }).jPlayer("play").jPlayer("stop");
        }
        return trackService.playTrack(trackID, currentProfileID).then(track => {
            if(track.Url) {
                dispatch({ type: types.PLAY_TRACK, track });
            }
            else {
                dispatch(reportBrokenTrack(trackID));
                //we can't play it so reset the play button
                dispatch(setTrackStatus(false, false));
                $('body').removeClass('showplayer');   
            }
        }).catch(error => {
            throw(error);
        });
    };
}

export function playPauseTrack(trackID, currentProfileID) {
    return (dispatch, getState) => {
        const tracks = getState().tracks;        
        $('body').addClass('showplayer');
        //we want to play a different track, or it's the same track but it's finished and we want to play it again
        if(tracks.nowPlaying.ID != trackID || (!tracks.trackPlaying && !tracks.trackPaused)) {
            //the user has selected a different track to play, set the ID but no data yet and set it to playing
            dispatch({ type: types.TRACK_CHANGED, track: { ID: trackID }});
            dispatch(setTrackStatus(true, false));
            dispatch(playTrack(trackID, currentProfileID));
        }
        else if(tracks.trackPlaying) {
            //pause the track
            dispatch(setTrackStatus(false, true));
        }
        else if(tracks.trackPaused) {
            //resume the track
            dispatch(setTrackStatus(true, false));
        }
    };    
}

export function reportBrokenTrack(trackID) {  
    return function(dispatch) {
        return trackService.reportBrokenTrack(trackID).then(response => {
            //we should always get an error returned
        }).catch(error => {
            let message = error.message;
            if(message.startsWith('["')) {
                message = JSON.parse(message).join('<br />');
            }
            swal('Ahh...', message, {
                button: "Ok!",
              });
        });
    };
}

export function setTrackStatus(playing, paused) {
    return function(dispatch) {
        const status = { playing, paused };
        dispatch({ type: types.SET_TRACK_STATUS, status });
    }    
}

export function increaseTrackRating(trackID, currentProfileID) {
    return function(dispatch) {
        return trackService.increaseRating(trackID, currentProfileID).then(rating => {
            dispatchRatingChange(dispatch, trackID, rating, currentProfileID);      
            const toastrService = new ToastrService;
            toastrService.showSuccess('', 'Thanks for rating this track!');     
            return rating;     
        }).catch(error => {
            if(error.message.indexOf('hasn\'t been played') > -1) {
                swal('Here\'s how it works...', 'Listen to a track and if you like it, click the turn me up button to increase the LoudUp rating!', {
                    button: "Ok, got it!",
                  });
            }
            else {
                const toastrService = new ToastrService;
                toastrService.showError('', error.message);
            }
            throw(error);
        });
    };
}

function dispatchRatingChange(dispatch, trackID, rating, currentProfileID) {
    const trackRating = { id: trackID, rating: rating.Rating, currentProfileID, trackProfileID: rating.RoleID };
    dispatch({ type: types.UPDATE_TRACK_RATING, trackRating });
    const roleRating = { id: rating.RoleID, rating: rating.RoleRating }
    dispatch({ type: types.UPDATE_ROLE_RATING, roleRating });
    //reload the charts
    dispatch(getCharts(true));
}

export function decreaseTrackRating(trackID, currentProfileID){
    return function(dispatch) {
        return trackService.decreaseRating(trackID, currentProfileID).then(rating => {
           dispatchRatingChange(dispatch, trackID, rating, currentProfileID);            
           const toastrService = new ToastrService;
           toastrService.showSuccess('', 'You have removed your rating!');      
           return rating;    
       }).catch(error => {
            const toastrService = new ToastrService;
            toastrService.showError('', 'Sorry, something went wrong, unable to remove track rating');
            throw(error);
        });
    };
}